import React, { forwardRef, CSSProperties, HTMLAttributes } from 'react';
import classnames from 'classnames';

export interface Props extends HTMLAttributes<HTMLDivElement> {}

const styleContent: CSSProperties = {
  position: 'absolute',
  top: '0',
  left: '0',
  height: '100%',
  width: '100%',
};

/**
 * The VizHTML component adds a HTML layer for the visualisation. Any number
 * of these can be used, but only HTML components should be used inside.
 */
const VizHTML = forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  const { className, style, ...rest } = props;

  return (
    <div { ...rest }
        className={ classnames('Bitviz__content Bitviz__content-html', className) }
        ref={ ref }
        style={ { ...styleContent, ...style } } />
  );
});

export default VizHTML;
